(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .factory('StorageService', StorageService);

    StorageService.$inject = ['$http', '$localStorage' ];

    function StorageService ($http, $localStorage ) {
        var service = {
            setTotal: setTotal,
            getTotal: getTotal
            
        };

        return service;
        function setTotal(total){
            $localStorage.total = total;
        }
        function getTotal(){
            return $localStorage.total;
        }

        
    }
})();
